import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';
export function Modal({ isOpen, onClose, title, children, size = 'md', footer }) {
    const overlayRef = useRef(null);
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape')
                onClose();
        };
        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = '';
        };
    }, [isOpen, onClose]);
    if (!isOpen)
        return null;
    const sizeClasses = {
        sm: 'max-w-md',
        md: 'max-w-lg',
        lg: 'max-w-2xl',
        xl: 'max-w-4xl',
    };
    return (_jsx("div", { ref: overlayRef, className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50", onClick: (e) => {
            if (e.target === overlayRef.current)
                onClose();
        }, children: _jsxs("div", { className: cn('relative w-full bg-white rounded-xl shadow-xl flex flex-col max-h-[90vh]', sizeClasses[size]), role: "dialog", "aria-modal": "true", "aria-labelledby": "modal-title", children: [_jsxs("div", { className: "flex items-center justify-between px-6 py-4 border-b border-gray-200", children: [_jsx("h2", { id: "modal-title", className: "text-lg font-semibold text-gray-900", children: title }), _jsx("button", { onClick: onClose, className: "rounded-md p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors", "aria-label": "Close", children: _jsx(X, { className: "h-4 w-4" }) })] }), _jsx("div", { className: "flex-1 overflow-y-auto px-6 py-4", children: children }), footer && (_jsx("div", { className: "border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3", children: footer }))] }) }));
}
